import { type FunctionalComponent, h } from '@stencil/core';
import { ConversationalSearchLabelWithSection } from '../label-with-section/label-with-section';

export interface IConversationalSearchFeedback {
  text: string;
  boldedPartText?: string;
  bannerVariant?: boolean;
  tooltipText?: string;
}

export const ConversationalSearchFeedback: FunctionalComponent<
  IConversationalSearchFeedback
> = (props) => {
    return (
      <div>
        <div class={{'conversational-search-feedback': true, 'conversational-search-feedback--banner': props.bannerVariant}}>
          <ConversationalSearchLabelWithSection text={props.text} partial={props.boldedPartText}>
          </ConversationalSearchLabelWithSection>
        </div>
        <se-tooltip
          color="alternative"
          class="outro-tooltip"
        >
          <qds-button slot="trigger" importance='subdued' icon-only="true" icon-name='information-circle-solid'/>
          <se-tooltip-content>
            <span innerHTML={props.tooltipText}></span>
          </se-tooltip-content>
        </se-tooltip>
      </div>
    );
};
